import { useEffect } from 'react';

const CSS_VAR = '--app-audio-sheet-top';

function measureHeaderTop() {
  if (typeof document === 'undefined') return 0;
  const el =
    document.querySelector('.support-open-disc-shell-header') ||
    document.querySelector('.products-sticky-header');
  if (!el) return 0;
  return Math.round(el.getBoundingClientRect().height);
}

/** Sets --app-audio-sheet-top so full-screen sheets sit below the visible app header. */
export function useAppShellHeaderOffset(active) {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;

    const apply = () => {
      document.documentElement.style.setProperty(CSS_VAR, `${measureHeaderTop()}px`);
    };

    apply();
    window.addEventListener('resize', apply);
    const ro =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(apply)
        : null;
    const header =
      document.querySelector('.support-open-disc-shell-header') ||
      document.querySelector('.products-sticky-header');
    if (ro && header) ro.observe(header);

    return () => {
      window.removeEventListener('resize', apply);
      ro?.disconnect();
      document.documentElement.style.removeProperty(CSS_VAR);
    };
  }, [active]);
}

export function useMobileAudioLayout() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 960px)').matches;
}
